class HeroSliderSync extends HTMLElement {
  connectedCallback() {
    this.textPanels = Array.from(this.querySelectorAll('[data-hsm-text-panel]'));
    this.slides = Array.from(this.querySelectorAll('[data-hsm-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-hsm-dot]'));

    if (this.slides.length < 2) return;

    this.currentIndex = 0;
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 6000;
    this.timer = null;

    this.applyColors(this.textPanels[0]);

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
        this.restartAutoplay();
      });
    });

    this.prevBtn = this.querySelector('[data-hsm-prev]');
    this.nextBtn = this.querySelector('[data-hsm-next]');

    this.prevBtn?.addEventListener('click', () => {
      this.goTo(this.currentIndex - 1);
      this.restartAutoplay();
    });
    this.nextBtn?.addEventListener('click', () => {
      this.goTo(this.currentIndex + 1);
      this.restartAutoplay();
    });

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());
    this.addEventListener('focusin', () => this.stopAutoplay());
    this.addEventListener('focusout', () => this.startAutoplay());

    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  goTo(index) {
    if (index === this.currentIndex) return;
    const total = this.slides.length;
    const nextIndex = ((index % total) + total) % total;

    this.textPanels[this.currentIndex]?.classList.remove('is-active');
    this.slides[this.currentIndex]?.classList.remove('is-active');
    this.dots[this.currentIndex]?.classList.remove('is-active');
    this.dots[this.currentIndex]?.setAttribute('aria-selected', 'false');

    this.textPanels[nextIndex]?.classList.add('is-active');
    this.slides[nextIndex]?.classList.add('is-active');
    this.dots[nextIndex]?.classList.add('is-active');
    this.dots[nextIndex]?.setAttribute('aria-selected', 'true');

    this.applyColors(this.textPanels[nextIndex]);

    this.currentIndex = nextIndex;
  }

  applyColors(panel) {
    if (!panel) return;
    const bg = panel.dataset.bg;
    const color = panel.dataset.color;
    if (bg) this.style.setProperty('--hsm-active-bg', bg);
    if (color) this.style.setProperty('--hsm-active-color', color);
  }

  next() {
    this.goTo(this.currentIndex + 1);
  }

  startAutoplay() {
    if (!this.autoplayEnabled || this.timer) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = setInterval(() => this.next(), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}

if (!customElements.get('hero-slider-sync')) {
  customElements.define('hero-slider-sync', HeroSliderSync);
}